module.exports = __webpack_public_path__ + "static/media/parts-marketing-news-slide.7faa62ba.jpg";